<h2 mat-dialog-title class="dialog-title">Invite User</h2>
<form [formGroup]="inviteUserForm">
    <div mat-dialog-content>
        <mat-form-field class="form-field">
            <mat-label>Email</mat-label>
            <input type="email" matInput formControlName="email" />
            @if (inviteUserForm.controls['email'].hasError('email') && !inviteUserForm.controls['email'].hasError('required')) {
                <mat-error> Please enter a valid email address </mat-error>
            }
            @if (inviteUserForm.controls['email'].hasError('required')) {
                <mat-error> Email is <strong>required</strong> </mat-error>
            }
        </mat-form-field>

        <mat-form-field class="form-field">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" />
            @if (inviteUserForm.controls['name'].hasError('required')) {
                <mat-error> Name is <strong>required</strong> </mat-error>
            }
        </mat-form-field>

        <div class="permissions-wrapper mb-2">
            <h3 class="permissions-title">Site Permissions</h3>
            <mat-button-toggle-group (change)="toggleButtonChange($event)" name="permissions">
                @for (role of roles; track role) {
                    <mat-button-toggle class="mat-button-toggle" [checked]="selectedRoleButton === role" [value]="role">
                        <span class="role-toggle-button">{{ role }}</span>
                    </mat-button-toggle>
                }
            </mat-button-toggle-group>
        </div>

        @if (data.permissionGroups) {
            <div class="permissions-container">
                @for (permissionGroup of data.permissionGroups; track permissionGroup) {
                    <div class="permission-row">
                        <div class="permission-groups-column">{{ permissionGroup.group }}</div>
                        <div class="checkboxes-column">
                            @for (permission of permissionGroup.permissions; track permission) {
                                <span>
                                    <mat-checkbox
                                        [checked]="activePermissionsIds.includes(permission.id) || permission.name === 'site_read'"
                                        (change)="checkboxChange($event)"
                                        [id]="permission.id"
                                        [disabled]="permission.name === 'site_read'"
                                        color="primary"
                                        class="mr-4"
                                        >{{ permission.category }}
                                    </mat-checkbox>
                                </span>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>
    <div class="footer-wrapper" mat-dialog-actions>
        <button color="primary" mat-button (click)="changePermissions()">{{ editMode ? 'Edit' : 'Invite' }}</button>
    </div>
</form>
